import { isMobile } from './shared/helpers';

if (isMobile) {
    import('./mobile/bootstrap').then(({ initialize }) => {
        initialize();
    });
} else {
    import('./desktop/bootstrap').then(({ initialize }) => {
        initialize();
    });
}
